<template>
  <li class="nav-item dropdown" :class="[`menu-level-${level}`]">
    <d-link
      class="nav-link"
      :class="{ 'dropdown-toggle': hasChildren }"
      :to="item.to"
      v-d-toggle="hasChildren ? collapseId : null"
      @click="handleClick"
    >
      <div
        class="item-icon-wrapper"
        v-if="item.htmlBefore"
        v-html="item.htmlBefore"
      />

      <span>{{ item.title }}</span>

      <div
        class="item-icon-wrapper"
        v-if="item.htmlAfter"
        v-html="item.htmlAfter"
      />
    </d-link>

    <d-collapse
      v-if="hasChildren"
      :id="collapseId"
      class="dropdown-menu dropdown-menu-small"
    >
      <sidebar-item
        v-for="(child, index) in checkAccess(item.items)"
        :key="index"
        :item="child"
        :collapse-id="`${collapseId}-${index}`"
        :level="level + 1"
        @toggle-sidebar="$emit('toggle-sidebar')"
      />
    </d-collapse>
  </li>
</template>

<script>
export default {
  name: 'sidebar-item',
  props: {
    item: Object,
    collapseId: String,
    level: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    hasChildren() {
      return this.item.items && this.item.items.length;
    },
    isAdmin() {
      const { user } = this.$store.state.user;
      if (user.settings.user_type_id === 1) {
        return true;
      }
      return false;
    },
  },
  methods: {
    handleClick() {
      if (!this.hasChildren) {
        this.$emit('toggle-sidebar');
      }
    },
    checkAccess(items) {
      return items.filter(item => {
        if (!this.isAdmin && 'isAdmin' in item) {
          return this.isAdmin;
        }
        return true;
      });
    },
  },
};
</script>
